import React, { Component } from 'react';

import modules from 'modules';
import ErrorBoundary from 'partials/ErrorBoundary';
import Overlay from 'partials/Overlay';

class Builder extends Component {

    render() {
        const { data, page } = this.props;
        
        return (
            <div>
                <div className="modules">
                    {data && data.map((module, i) => {

                        if(!modules[module.acf_fc_layout]) {
                            return <p key="nomodule" style={{color: 'red'}}>Module "{module.acf_fc_layout}" does not exist</p>
                        }

                        return (
                            <div key={i} className={'module-'+module.acf_fc_layout}>
                                <ErrorBoundary for={'Module '+module.acf_fc_layout}>
                                    {React.createElement(modules[module.acf_fc_layout], { 
                                                data: module, 
                                                page: page, 
                                                idx: i, 
                                                prevModule: i > 0 ? data[i - 1].acf_fc_layout : false, 
                                                last: data.length - 1 == i
                                            }
                                        )
                                    }
                                </ErrorBoundary>
                                <Overlay />
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    }
}

export default Builder;